import {Maybe} from "../../types/Maybe";
import {RRCalendarDayType} from "../../types/RRCalendarDayType";
import {RRDayType} from "../../types/RRDayType";

interface Props {
    colIndex: number;
    onClick?: (item: Maybe<RRCalendarDayType>) => void;
    offDay: Maybe<RRCalendarDayType>
}

export default function CalendarNoEventsCellContent(props: Props) {
    if (props.offDay) return (<td className={"w-50px td-left-dbl-border"}>
        <div className={"w-100 cursor-pointer bg-danger text-light p-1 text-center"}
             onClick={() => props.onClick && props.onClick(props.offDay)}>
            {dayTypeToString(props.offDay.dayType)}&nbsp;
        </div>
    </td>);
    return (<td className={
        (props.colIndex % 2 === 0 ? "bg-secondary-light" : "bg-light") + " td-left-dbl-border1"}
                onClick={() => props.onClick && props.onClick(null)}
    >
        <div className={"w-100 w-50px h-100 cursor-pointer"} style={{height: "40px"}}>
            &nbsp;
        </div>
    </td>);
}

export function dayTypeToString(dayType: RRDayType) {
    switch (dayType) {
        case "HOLIDAY": return "ОТПУСК";
        case "DAYOFF": return "ОТСЪСТВИЕ";
        case "SICK": return "БОЛНИЧЕН";
    }
}
